import { defineStore } from 'pinia';

export const useCountryStore = defineStore('country', {
  // State 可以直接复制过来
  state: () => ({
    // 注册、绑定、换绑、机构等页面的国家列表
    regCountryList: [],
    // 全部国家列表，包括我们自定义的国家
    allCountryList: [],
    // 可以kyc认证的国家列表
    kycCountryList: [],
    // 有区号的所有国家列表，使用场景是：登陆、找回密码
    allAreaCodeList: [],
  }),
  actions: {
    /** 设置注册/换绑等国家列表 */
    SET_REG_COUNTRY_LIST(countryList) {
      this.regCountryList = countryList;
    },
    /** 设置kyc国家列表 */
    SET_KYC_COUNTRY_LIST(kycCountryList) {
      this.kycCountryList = kycCountryList;
    },
    /** 设置全部国家列表 */
    SET_ALL_COUNTRY_LIST(allCountryList) {
      this.allCountryList = allCountryList;
    },
    /** 设置有区号的国家列表 */
    SET_ALL_AREA_CODE_LIST(allAreaCodeList) {
      this.allAreaCodeList = allAreaCodeList;
    },
  },
});
